/* eslint-disable react/prop-types */
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { firebase } from "store/slices/firebaseSlice";

const HistoryRoute = ({ Component }) => {
  const { isAuth, showHistory } = useSelector(firebase);
  if (!isAuth) return <Navigate to="/authentication/sign-in" />;
  if (!showHistory) return <Navigate to="/tables" />;
  return <Component />;
};

export default HistoryRoute;
